import {Activity, DatesState, MasterState, MastersState, ServicesState} from '@target-web/leadads-form-view';
import {apiUrl, headers} from './constants';
import {fetchRetry} from './fetch';
import {VkCapthaInfoResponse, VKWebAppGetCustomSdkUserInfoResult} from './types';

type CommentsRes = {
    data: {
        success: boolean;
        data: MasterState['comments'];
    };
    http_status_code: number;
};

type BookStaffRes = {
    data: {
        data: MastersState['masters'];
        success: boolean;
    };
};

type BookStaffSeancesRes = {
    data: {
        success: boolean;
        data: {
            seance_date: MastersState['masters'][number]['seance_date'];
            seances: MastersState['masters'][number]['seances'];
        };
    };
};

type ServicesRes = {
    data: {
        data: {
            services: ServicesState['services'];
            category: ServicesState['categories'];
        };
        success: boolean;
    };
    http_status_code: number;
};

type ServicesCheckRes = {
    data: {
        data: {
            id: number;
            attributes: {
                is_bookable: boolean;
            };
        }[];
    };
    http_status_code: number;
};

type DatesRes = {
    data: {
        data: DatesState['dates'];
        success: boolean;
    };
    http_status_code: number;
};

type TimesRes = {
    data: {
        data: DatesState['times'];
        success: boolean;
    };
    http_status_code: number;
};

type ActivitiesDatesRangeRes = {
    data: {
        data: {
            min_date: string | null;
            max_date: string | null;
        };
        success: boolean;
    };
    http_status_code: number;
};

type ActivitiesDatesRes = {
    data: {
        data: string[];
        success: boolean;
    };
    http_status_code: number;
};

type ActivitiesRes = {
    data: {
        data: Activity[];
        success: boolean;
    };
    http_status_code: number;
};

export const fetchVkCapthaInfo = (leadFormDataHash: string): Promise<VkCapthaInfoResponse> => {
    // поход в наш бек за ссылкой на капчу
    return fetchRetry(`${apiUrl}/check_user?${new URLSearchParams({lead_form_data: leadFormDataHash})}`, {
        headers,
    }).then(async (res) => {
        if (!res.ok) {
            throw new Error(JSON.stringify(await res.json()));
        }
        return (await res.json()) as VkCapthaInfoResponse;
    });
};

export const fetchUserInfo = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/user_info?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as VKWebAppGetCustomSdkUserInfoResult;
        return r;
    });
};

export const fetchComments = async (searchParams?: string) => {
    return await fetchRetry(`${apiUrl}/yclients/comments?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as CommentsRes;
        return r.data.data;
    });
};

export const fetchMasters = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/book_staff?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as BookStaffRes;
        if (r.data.success) {
            return r.data.data;
        }
        throw new Error('Что-то пошло не так(');
    });
};

export const fetchMasterSeances = (id: number, timesSearchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/book_staff_seances/${id}?${timesSearchParams}`, {
        headers,
    }).then(async (r) => (await r.json()) as BookStaffSeancesRes);
};

export const fetchServices = async (searchParams?: string) => {
    return await fetchRetry(`${apiUrl}/yclients/book_services?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as ServicesRes;
        return r;
    });
};

export const fetchCheckServices = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/booking_locations_services?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as ServicesCheckRes;
        return r;
    });
};

export const fetchDates = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/book_dates?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as DatesRes;
        return r;
    });
};

export const fetchTimes = (staffId: number, selectedDay: string, searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/book_times/${staffId}/${selectedDay}?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as TimesRes;
        return r;
    });
};

export const fetchActivitiesDatesRange = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/search_activity_dates_range?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as ActivitiesDatesRangeRes;
        return r.data.data;
    });
};

export const fetchActivitiesDates = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/search_activity_dates?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as ActivitiesDatesRes;
        return r.data.data;
    });
};

export const fetchActivities = (searchParams?: string) => {
    return fetchRetry(`${apiUrl}/yclients/search_activity?${searchParams}`, {
        headers,
    }).then(async (res) => {
        const r = (await res.json()) as ActivitiesRes;
        return r.data.data;
    });
};
